import type { TFunction } from 'i18next';

const PASSWORD_PATTERN = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;

export const getPasswordRule = (t: TFunction) => ({
  validator: (_: unknown, value: string) => {
    if (!value) {
      return Promise.resolve();
    }
    if (value.length < 8) {
      return Promise.reject(new Error(t('forms.validation.passwordTooShort')));
    }
    if (/^\d+$/.test(value)) {
      return Promise.reject(new Error(t('forms.validation.passwordOnlyDigits')));
    }
    if (/^[A-Za-z]+$/.test(value)) {
      return Promise.reject(new Error(t('forms.validation.passwordOnlyLetters')));
    }
    if (!PASSWORD_PATTERN.test(value)) {
      return Promise.reject(new Error(t('forms.validation.passwordInvalid')));
    }
    return Promise.resolve();
  },
});
